import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Scrollbar } from 'swiper';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postNewsItem, CMS_BASE_URL, postTerms } from '../../redux/action';

import 'swiper/css/pagination';
import 'swiper/css';
import './home.css'; 
import '../common/common.css'; 

import homeBanner from '../../images/homeBanner.png';

class Home extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    		terms: {}
	    };
    }

	componentWillMount() {

	}

	componentDidMount() {

		
		postTerms({}).then(res => {
				this.setState({ 
					terms: res.data.terms
				})
			}, this)
		
		postNewsItem({}).then(res => {
				this.setState({ 
					items: res.data 
				})
			}, this)
	}


	render() {

		const news = [
			{
				id: 1,
				thumb: "/images/news/news1.png",
				date: "13 June 2022",
				title: "Trastuzumab deruxtecan reduced the risk of disease progression or death by 50% vs. chemotherapy in patients with HER2-low metastatic breast cancer"
			},
			{
				id: 2,
				thumb: "/images/news/news2.png",
				date: "24 May 2022",
				title: "Slide deck: New treatment updates on HER2+ unresectable breast cancer"
			},
			{
				id: 3,
				thumb: "/images/news/news3.png",
				date: "16 May 2022",
				title: "ASCO updates on metastatic breast cancer"
			},
			{
				id: 4,
				thumb: "/images/news/news4.png",
				date: "8 May 2022",
				title: "Event: How to manage GI adverse reactions?"
			},
			{
				id: 5,
				thumb: "/images/news/news1.png",
				date: "13 June 2022",
				title: "Trastuzumab deruxtecan reduced the risk of disease progression or death by 50% vs. chemotherapy in patients with HER2-low metastatic breast cancer"
			},
			{
				id: 6,
				thumb: "/images/news/news2.png",
				date: "24 May 2022",
				title: "Slide deck: New treatment updates on HER2+ unresectable breast cancer"
			}
		];

		return(
			<div>
				<Header />
				<div className="mainContainer">
					<img className="banner" src={homeBanner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>News and updates</h2>
						</div>
						<div className="bodyContent containerMaxWidth">
							<div>
								<Swiper
							      spaceBetween={10}
							      slidesPerView={1}
							      modules={[Pagination, Scrollbar]}
							      scrollbar={{ draggable: true }}
							      pagination={{ clickable: true }}
							      onSlideChange={() => console.log('slide change')}
							      onSwiper={(swiper) => console.log(swiper)}
							      breakpoints={{
							      	768: {
							      		slidesPerView: 3,
								    	spaceBetween: 20
							      	},
							      	1024: {
							      		slidesPerView: 4,
								    	spaceBetween: 20
							      	}
							      }}
							    >
							    	{
							    		(this.state.items || []).map((item, idx) => {
							    			return (
										      <SwiperSlide className="sliderItem">
										      	<img className="sliderThumb" src={CMS_BASE_URL + "/storage/" + item.thumbnail} />
										      	<p className="sliderDate">{item.date}</p>
										      	<p className="sliderTitle">{item.title}</p>
										      	<div className="readMoreBtn"><a href={"/news-and-updates/"+item.id}><span>+ Read more</span></a></div>
										      </SwiperSlide>
						    				);
							    		})
							    	}
							    </Swiper>
							</div>
						</div>
					</div>
					<div className="sectionContainer blueBackground">
						<div className="headline containerMaxWidth">
							<h2>About this website</h2>
						</div>
						<div className="bodyContent containerMaxWidth">
							<p>
							This website is brought to you by AstraZeneca Hong Kong Limited and Daiichi Sankyo Hong Kong Limited. This website contains materials for the education of healthcare professionals on Trastuzumab deruxtecan (T-DXd).
							<br/><br/>
							Please report Individual Case Safety Report (ICSR)/Adverse Event (AE) to Daiichi-Sankyo via <a href="pv_hk@daiichisankyo.com" target="_blank">pv_hk@daiichisankyo.com</a>
							</p>
						</div>
						<div className="sectionContainer">
							<div class="sectionContainer">
								<div class="headline containerMaxWidth">
									<h2>PRIVACY NOTICE</h2>
								</div>
								<div class="bodyContent containerMaxWidth">
									<div class="text">
									<p>Please refer to the terms of <a href="https://www.azprivacy.astrazeneca.com/asia-pacific/hongkong/en/privacy-notices.html#accordion-list-item-75b4bb02e1" target="_blank" rel="noopener">Astrazeneca's privacy policy</a> and <a target="_blank" href="https://www.daiichisankyo.com.hk/Privacy/">Daiichisankyo's privacy policy</a>.&nbsp;</p>
									
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<Footer />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Home));